export var actionTypes = [
    {
        name: 'Story',
        type: 'story',
        icon: 'feather-alt',
        descr: 'Orientez votre utilisateur vers une page de contenu créée sur mesure.'
    },
    {
        name: 'Redirection Web',
        type: 'redirection',
        icon: 'link',
        descr: 'Orientez votre utilisateur vers une page web existante.'
    },
    {
        name: 'Réalitée augmentée 3D',
        type: 'ra3d', // 'disabled',
        icon: 'cubes',
        descr: 'Chargez vous-même vos contenus 3D.'
    },
    {
        name: 'Réalitée augmentée DOM',
        type: 'raDom', // 'disabled',
        icon: 'clone',
        descr: 'Chargez vous-même vos contenus 3D.'
    },
    {
        name: 'Viewer 3D',
        type: 'viewer3d', // 'disabled',
        icon: 'cube',
        descr: 'Visualiser un contenu 3D'
    },
    {
        name: 'Video / Image 360°',
        type: 'content360', // 'disabled',
        icon: 'photo-video',
        descr: 'Visualiser un contenu en 360°'
    }
];
